import { Box, IconButton, Tooltip } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeIcon from '@mui/icons-material/Home';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTrackingNavigation } from './trackingNavigation';

export default function NavigationActions() {
    const navigate = useNavigate();
    const location = useLocation();
    const tracking = useTrackingNavigation();

    const goBack = () => {
        if (tracking.isBusy()) return;
        if (location.key === 'default') {
            navigate('/');
            return;
        }
        navigate(-1);
    };

    return (
        <Box sx={{display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0}}>
            <Tooltip title='Previous page'>
                <IconButton disabled={tracking.busy} color='inherit' aria-label='Previous page' onClick={goBack}>
                    <ArrowBackIcon />
                </IconButton>
            </Tooltip>
            <Tooltip title='Home'>
                <IconButton disabled={tracking.busy} color='inherit' aria-label='Home' onClick={() => {if (!tracking.isBusy()) navigate('/');}}>
                    <HomeIcon />
                </IconButton>
            </Tooltip>
        </Box>
    );
}
